import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

@Pipe({
	name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {
	transform<T>(array: T[], field: string): T[] {
		if (!Array.isArray(array)) {
			return [];
		}

		return array.sort((a, b) => {
			const fieldA = stringForSorting(get(a, field, '').toString() ?? '');
			const fieldB = stringForSorting(get(b, field, '').toString() ?? '');
			return fieldA.localeCompare(fieldB);
		});
	}
}

// Remove all non-ASCII characters and convert to lowercase
export function stringForSorting(str: string | undefined): string {
	if (!str) {
		return '';
	}

	return str
		.replace(/[^\u0020-\u007e]/g, '')
		.trim()
		.toLowerCase();
}
